import type { JSX } from 'react';
import { Link } from 'react-router';
import {
  FOOTER_ATTRIBUTION,
  FOOTER_INDEPENDENCE,
  METHODOLOGY_LINK_LABEL,
  METHODOLOGY_PATH,
  SOURCE_URL,
} from '../labels';

/**
 * On every route, which is how the redesign keeps the attribution and independence claims visible
 * while the pages themselves shed their prose (ux-spec §6 row 1).
 */
export function SiteFooter(): JSX.Element {
  return (
    <footer className="mt-auto border-t border-line">
      <div className="mx-auto w-full max-w-[76rem] px-4 py-4 pb-8 text-small text-ink-muted sm:px-6">
        <p className="my-0.5">
          {FOOTER_ATTRIBUTION.lead}{' '}
          <a href={SOURCE_URL} rel="noreferrer" className="text-accent hover:text-accent-deep">
            {FOOTER_ATTRIBUTION.source}
          </a>{' '}
          {FOOTER_ATTRIBUTION.tail}{' '}
          <Link to={METHODOLOGY_PATH} className="text-accent hover:text-accent-deep">
            {METHODOLOGY_LINK_LABEL}
          </Link>
        </p>
        <p className="my-0.5">{FOOTER_INDEPENDENCE}</p>
      </div>
    </footer>
  );
}
